import { createAction } from "@reduxjs/toolkit";
import { SLICE_NAME } from "./Slice";
export const getEducationAsyncAction = createAction(`${SLICE_NAME}/getEducationItems`);
export const getEducationArticlesAsyncAction = createAction(`${SLICE_NAME}/getEducationArticles`);
